import { GetStaticProps } from "next";

import { getLegalMentionsPageTranslations } from "../../../api/translations/legalMentions";
import { LegalPageType } from "../../../api/types/translations";
import LegalMentions from "../../../components/layout/Footer/Legals/LegalMentions";
import Header from "../../../components/layout/Header";

interface Props {
  translations?: LegalPageType;
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const translations = await getLegalMentionsPageTranslations("es");
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return { props: { translations: translations.data } };
};

const LegalMentionsPage = ({ translations }: Props) => {
  return (
    <Header
      title="EatSalad - Aviso Legal"
      description="Salade sur mesure à emporter et en livraison | Eat Salad"
    >
      {translations ? <LegalMentions translations={translations} /> : <></>}
    </Header>
  );
};

export default LegalMentionsPage;
